export default "__VITE_ASSET__DSyZeFW___"